// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useAppSelector } from '@advisor-app/store/store';
import { UserInformation, Subscriptions } from '@advisor-app/features/account';
import {
  selectExpirationDate,
  selectUserData,
} from '@shared/data-access/slices/user';
import { Topbar } from '@advisor-app/features/ui/layout/topbar';
import { Button } from '@mui/material';
import { AppLink } from '@advisor-app/routes/AppLink';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

export const Account: FC = () => {
  const { t } = useTranslation();
  const user = useAppSelector(selectUserData);

  const expirationDate = useAppSelector(selectExpirationDate);

  return (
    <div data-testid="boxLoginContent" className="flex h-full flex-col pb-24">
      <div className="flex flex-row items-center justify-between">
        <AppLink to="/" className="!mx-7" data-testid="back-button">
          <Button color="secondary" type="button">
            {t('accounts.back-to-dashboard', { ns: 'components' })}
          </Button>
        </AppLink>

        <Topbar hidden />
      </div>
      <UserInformation user={user!} expirationTimestamp={expirationDate!} />
      <Subscriptions />
    </div>
  );
};

export default Account;
